<template>
    <div>
        <b-container fluid>
            <b-row class="wrapper-text">
                <b-col md="5" class="mb-4">
                    <h1>With <span class="red">more than 20 years</span> in the restaurant industry.</h1>
                </b-col>
                <b-col md="7" class="mb-4">
                    <p>Provinco Kitchen Solutions was born with the main objective of providing cutting-edge products to the Mexican market at the best prices.</p>
                    <p>Provinco currently offers consulting services and sales of equipment for industrial kitchens through a network of distributors present in more than 15 states in Mexico.</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6">
                    <img src="../assets/img/img_20years_1.jpg" class="img-fluid mb-4" alt="">
                </b-col>
                <b-col md="6">
                    <img src="../assets/img/img_20years_2.jpg" class="img-fluid mb-4" alt="">
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>
.wrapper-text{
    padding: 10% 5%;
}
@media (max-width: 1600px){
  h1{
    font-size: 45px;
  }
}

@media (max-width: 768px){
    h1{
        font-size: 35px;
    }
    .wrapper-text{
        padding: 15% 5%;
    }

}

</style>